import { menuAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys)

const baseStyle = definePartsStyle({
  item: {
    bg: 'white',
    py: 2.5,
    px: 4,
    _hover: {
      bg: '#f6f6f6',
    },
    fontWeight: 'bold',
    _first: {
      pt: 3.5,
    },
    _last: {
      pb: 3.5,
    },
  },
  list: {
    overflow: 'hidden',
    rounded: '1.25rem',
    boxShadow: '0px 4px 30px 0px rgba(0, 0, 0, 0.25)',
    border: '0px',
    bg: 'white',
    py: 0,
    willChange: 'transform, opacity',
  },
  divider: {
    p: 0,
    color: '#e0e0e0',
    mx: 4,
    borderWidth: 2,
  },
})

export const menuTheme = defineMultiStyleConfig({ baseStyle })
